<template>
  <div>
    <div class="panels">
      <table class="panel-rows mt-3">
        <thead>
          <tr>
            <th class="index">&nbsp;</th>
            <th class="length description brackets" :class="{'invisible': hasGrain !== 'lengte'}">
              <div class="brackettop left"></div>
              <div class="bracketside left"></div>
              <div class="bracketside right"></div>
              <div class="brackettop right"></div>
              Nerfricht.
            </th>
            <th class="width description brackets" :class="{'invisible': hasGrain !== 'breedte'}">
              <div class="brackettop left"></div>
              <div class="bracketside left"></div>
              <div class="bracketside right"></div>
              <div class="brackettop right"></div>
              Nerfricht.
            </th>
            <th class="amount">&nbsp;</th>
            <th class="description brackets" colspan="2">
              <div class="brackettop left"></div>
              <div class="bracketside left"></div>
              <div class="bracketside right"></div>
              <div class="brackettop right"></div>
              Lengte
            </th>
            <th class="description brackets" colspan="2">
              <div class="brackettop left"></div>
              <div class="bracketside left"></div>
              <div class="bracketside right"></div>
              <div class="brackettop right"></div>
              Breedte
            </th>
            <th class="reference">&nbsp;</th>
          </tr>
          <tr>
            <th class="index">&nbsp;</th>
            <th class="length">Lengte</th>
            <th class="width">Breedte</th>
            <th class="amount">Aantal</th>
            <th class="checkbox l1">L1</th>
            <th class="checkbox l2">L2</th>
            <th class="checkbox b1">B1</th>
            <th class="checkbox b2">B2</th>
            <th class="reference text-left">Paneelreferentie</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="panel in material.panels" :key="panel.id" class="panel-row bg-light">
            <td class="index">
              {{ panel.id }}
            </td>
            <td class="length">
              {{ panel.length }}
            </td>
            <td class="width">
              {{ panel.width }}
            </td>
            <td class="amount">
              {{ panel.amount }}
              <div class="user"/>
            </td>
            <td class="checkbox l1">
              <template v-if="panel.l1">
                <font-awesome-icon class="font-awesome-icon" icon="check"/>
              </template>
            </td>
            <td class="checkbox l2">
              <template v-if="panel.l2">
                <font-awesome-icon class="font-awesome-icon" icon="check"/>
              </template>
            </td>
            <td class="checkbox b1">
              <template v-if="panel.b1">
                <font-awesome-icon class="font-awesome-icon" icon="check"/>
              </template>
            </td>
            <td class="checkbox b2">
              <template v-if="panel.b2">
                <font-awesome-icon class="font-awesome-icon" icon="check"/>
              </template>
            </td>
            <td class="reference text-left">
              {{ panel.reference }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import { SAVE_ORDER_LOCAL_STORAGE, SELECT_MATERIAL } from '../../store/types'

  export default {
    props: ['material'],
    data() {
      return {}
    },
    computed: {
      product() {
        return this.material.product
      },
      side1() {
        return this.material.side1
      },
      side2() {
        return this.material.side2
      },
      hasGrain() {
        let top = !this.side1 ? this.product : this.side1
        return top.grain !== 'Geen' ? top.grain.toLowerCase() : false
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
